import { adminSettingsUtils } from 'utils/selectOptionsUtils';

import { EQuantityFormatKey } from '../../StoreSettings.types';

import {
  EAbbreviationDropdownType,
  IAbbreviationDropdownField,
  IAbbreviationDropdownOption,
  IAbbreviationOfferTab,
  IAbbreviationToggleField
} from './AbbreviationsSettingsV2.types';

export const ABBREVIATIONS_V2_TEXTS = {
  HEADER_TITLE: 'Quantity Abbreviations by Offer Type',
  HEADER_DESCRIPTION:
    'Set how offer quantities are abbreviated by offer type. The system uses the largest matching abbreviation and applies it per store component.',
  SHOW_FULL_NUMBER_LABEL: 'Show full number up to X digits',
  MAX_DIGITS_LABEL: 'Max digits',
  LOAD_ERROR: 'Unable to load settings. Please try again.',
  RETRY: 'Retry'
};

export const ABBREVIATION_OFFER_TABS: IAbbreviationOfferTab[] = [
  { key: EQuantityFormatKey.PRODUCTS, label: 'Bundles' },
  { key: EQuantityFormatKey.ROLLING_OFFER, label: 'Rolling Offers' },
  { key: EQuantityFormatKey.PROGRESS_BAR, label: 'Progress Bars' },
  { key: EQuantityFormatKey.TRIGGERED_POPUP, label: 'Triggered Popups' },
  { key: EQuantityFormatKey.SPECIAL_OFFER, label: 'Special Offers' },
  { key: EQuantityFormatKey.BALANCE, label: 'Balance' }
];

export const ABBREVIATION_DROPDOWN_FIELDS: IAbbreviationDropdownField[] = [
  {
    key: 'milSeparator',
    label: 'Thousands Separator',
    type: EAbbreviationDropdownType.SEPARATOR
  },
  {
    key: 'fractionalSeparator',
    label: 'Decimal Separator',
    type: EAbbreviationDropdownType.SEPARATOR
  },
  {
    key: 'digitsBasedAbbreviation',
    label: 'Digits Based Abbreviation',
    type: EAbbreviationDropdownType.BOOLEAN
  }
];

export const ABBREVIATION_TOGGLE_FIELDS: IAbbreviationToggleField[] = [
  { key: 'thousandShorthand', label: 'Thousands (K)' },
  { key: 'millionShorthand', label: 'Millions (M)' },
  { key: 'billionShorthand', label: 'Billions (B)' },
  { key: 'trillionShorthand', label: 'Trillions (T)' },
  { key: 'quadrillionShorthand', label: 'Quadrillions (Q)' },
  { key: 'quintillionShorthand', label: 'Quintillions (Qi)' },
  { key: 'sextillionShorthand', label: 'Sextillion (S)' },
  { key: 'septillionShorthand', label: 'Septillion (SP)' }
];

const toDropdownOptions = (
  options: { content: string; value: string }[]
): IAbbreviationDropdownOption[] =>
  options.map((option) => ({ value: option.value, label: option.content }));

export const ABBREVIATION_SEPARATOR_OPTIONS: IAbbreviationDropdownOption[] =
  toDropdownOptions(adminSettingsUtils.separatorOptions);

export const ABBREVIATION_BOOLEAN_OPTIONS: IAbbreviationDropdownOption[] =
  toDropdownOptions(adminSettingsUtils.trueFalseOptions);

export const MIN_DIGITS_WITHOUT_SHORTHAND = 3;

export const ABBREVIATION_SWITCH_CLASSNAME =
  'bg-base-input [&>span]:bg-base-background data-[state=checked]:!bg-indigo-600';

export const ABBREVIATIONS_V2_TEST_IDS = {
  root: 'abbreviations-v2',
  error: 'abbreviations-v2-error',
  retry: 'abbreviations-v2-retry',
  showFullNumber: 'abbreviations-v2-show-full-number',
  maxDigitsInput: 'abbreviations-v2-max-digits'
} as const;

export const getAbbreviationTabTestId = (key: EQuantityFormatKey): string =>
  `abbreviations-v2-tab-${key}`;

export const getAbbreviationToggleTestId = (key: string): string =>
  `abbreviations-v2-toggle-${key}`;

export const getAbbreviationDropdownTestId = (key: string): string =>
  `abbreviations-v2-dropdown-${key}`;
